<template>
  <div class="short-answer">
    <div class="content-stem">
      <span class="ques-num">{{ currentQuestion.showSerialNum }}</span>
      <span v-html="currentQuestion.content"/>
    </div>
    <strong>试问：指出报告中存在的问题并说明理由。</strong>
    <div class="sa-function clearfix"
         v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
      <ul class="">
        <li>
          <el-tooltip effect="dark" content="复制" placement="top">
            <a href="javascript:void(0)" @click="copyFn">
              <img src="@/assets/images/formula/icon-copy.png" alt="">
            </a>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark" content="剪切" placement="top">
            <a href="javascript:void(0)" @click="cutFn">
              <img src="@/assets/images/formula/icon-cut.png" alt="">
            </a>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark" content="粘贴" placement="top">
            <a href="javascript:void(0)" @click="pasteFn">
              <img src="@/assets/images/formula/icon-paste.png" alt="">
            </a>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip effect="dark" content="插入公式符号" placement="top">
            <a href="javascript:void(0)" @click="openFormula(0)">
              <img src="@/assets/images/formula/icon-gs.png" alt="">
            </a>
          </el-tooltip>
          <formula :visible.sync="visibleFm[0]" @toggleFn="insertWrite"/>
        </li>
        <li>
          <el-tooltip effect="dark" content="插入表格矩阵" placement="top">
            <a href="javascript:void(0)" @click="openTable(0)">
              <img src="@/assets/images/formula/icon-jz.png" alt="">
            </a>
          </el-tooltip>
          <matrix :visible.sync="visibleTable[0]" @toggleTable="insertMatrix" @delTable="deleteTable"/>
        </li>
      </ul>
    </div>
    <div class="sa-input" ref="saInput" v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
      <div class="quesContent" ref="quesContent">
        <!--<strong>请在下方答题区域内作答。</strong><br/>-->
        <div
          class="answerArea"
           ref="withoutChildAnswerArea"
           id="answerArea"
           contenteditable="true"
           @mouseup="mouseUpFn"
           v-html="currentQuestion.userAnswer">
        </div>
      </div>
    </div>
    <div class="sa-input sa-input-simple" ref="saInput" v-else>
      <div class="quesContent quesContent-simple" ref="quesContent">
        <!-- 单选题、判断题 -->
        <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
          <exam-single-choice></exam-single-choice>
        </template>
        <!-- 多选题 -->
        <template v-if="currentQuestion.quesTypeID === 2">
          <exam-multiple-choice></exam-multiple-choice>
        </template>
      </div>
    </div>

    <!--矩阵弹框-->
    <dialog-matrix
      :visible.sync="visibleMatrixTip"
    ></dialog-matrix>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Formula from '../formula'
  import Matrix from '../matrix'
  import editor from '@/mixins/editor'
  import DialogMatrix from '@/components/exam/DialogMatrix'
  import {
    ExamSingleChoice,
    ExamMultipleChoice,
  } from '@components/exam'

  export default {
    name: 'WithoutChildQuestion',
    components: {
      Formula,
      Matrix,
      ExamSingleChoice,
      ExamMultipleChoice,
      DialogMatrix
    },
    computed: {
      ...mapGetters([
        'currentQuestionIndex',
        'currentQuestion'
      ]),

    },

    mixins: [editor],
    data() {
      return {
        visibleTable: [false],// 矩阵显隐
        visibleMatrixTip:false, //矩阵提示弹框显隐
        visibleFm: [false],  //  公式显隐
        visibleIME: false,  //  输入法显隐
        smallIndex: 0,
        //容器对象
        rangeData: {  //  鼠标选中数据
          start: 0,
          end: 0,
          text: ''
        },
        editorContainer: null,
        currentFormulaID: '',  //  当前正在编辑的公式span的id
        blankSpan: '<span class="blankSpan" style="display:inline-block;width:1px;">&nbsp;</span>',
        formulaHtml: '<span id="span_formula_{0}" class="isFormula"></span><span id="span_Temp">&nbsp;</span><span class="blankSpan" style="display:inline-block;width:1px;">&nbsp;</span>',
        matrixHtml: '',
        timerMouseUP: null, // mouseUp计时器，光标问题临时解决方案

      }
    },
    mounted() {

    },
    methods: {
      setCurrentSmallContent() {
        if (this.currentQuestion.quesTypeID === 4 || this.currentQuestion.quesTypeID === 5) {
          if(this.timerMouseUP) {
            clearTimeout(this.timerMouseUP)
          }
          let domInput = this.$refs['withoutChildAnswerArea']
          let answer = domInput.innerHTML === '<br/>' ? '' : domInput.innerHTML
          let isAnswer = answer ? 1 : 0
          this.$store.dispatch('setUserAns', answer)
          this.$store.dispatch('setIsAns', isAnswer)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  $imgUrl: '~@/assets/images/formula/';
  .short-answer{
    padding: 8px 16px;
    .content-stem {
      height: 100%;
      line-height: 1.6;
      color: #000000;
      width: 100%;
      margin-bottom: 10px;
      .ques-num{
        display: inline-block;
        padding: 0 5px;
        background-color: #447dff;
        color: #fff;
        font-style: normal;
        border-radius: 3px;
        min-width: 25px;
        text-align: center;
        margin-right: 10px;
      }
    }
    strong{
      display: inline-block;
      margin-top: 25px;
      margin-bottom: 8px;
    }
    .sa-function{
      background: #f0f0f0;
      padding: 3px 8px;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid #ddd;
      border-bottom: none;
      position: relative;
      ul{
        margin-left: 8px;
        overflow: hidden;
        height: 34px;
        li{
          float: left;
          display: inline-block;
          width: 30px;
          border: 1px solid transparent;
          text-align: center;
          line-height: 30px;
          margin-right: 8px;
          a{
            display: inline-block;
            width: 30px;
            &:hover {
              background-color: #ddd;
              border: 1px solid #ccc;
            }
            img{
              position: relative;
              top:5px;
            }
          }
        }
      }
    }
    .sa-input{
      .answerArea{
        border: 1px solid #ddd;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 5px;
        outline: 0;
        overflow: auto;
        background-color: #fafafa;
        min-height: 250px;
        max-height: 500px;
        overflow-y: auto;
      }

    }
  }
</style>
